module.exports = __webpack_public_path__ + "a17d279f/img/delete-icon.eb7de062.svg";